import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type OfferShippingsV1 } from '@redteclab/api/clients/bully'

import { priceGetFormattedPrice } from '../../../../price'
import { shippingAccessorGetFormattedShippingTypeLabel } from '../../../model/shippingAccessor/shippingAccessorGetFormattedShippingTypeLabel'
import { shippingAccessorGetShippingTypeCode } from '../../../model/shippingAccessor/shippingAccessorGetShippingTypeCode'

export const ProductDeliveryInfoTableMarketplace: FC<{
  deliveryCosts: OfferShippingsV1[]
}> = ({ deliveryCosts }) => {
  const intl = useIntl()

  return (
    <table
      cellSpacing="0"
      className="w-full border-separate overflow-hidden rounded border border-dark-primary-min bg-light-primary-low text-center"
    >
      <tbody>
        {deliveryCosts.map((deliveryCostElement) => {
          const shippingTypeCode =
            shippingAccessorGetShippingTypeCode(deliveryCostElement)

          if (
            !shippingTypeCode ||
            typeof deliveryCostElement.totalShippingPrice !== 'number'
          ) {
            return null
          }

          const shippingLabel = shippingAccessorGetFormattedShippingTypeLabel({
            intl,
            shippingTypeCode,
          })

          return (
            <tr className="group" key={`delivery-cost-${shippingTypeCode}`}>
              <td className="h-16 border-t border-dark-primary-min pl-5 text-left font-bold capitalize text-dark-primary-max group-first:border-t-0">
                {shippingLabel}
              </td>
              <td className="h-16 border-t border-dark-primary-min pr-5 text-right capitalize text-dark-primary-max group-first:border-t-0">
                {priceGetFormattedPrice(
                  deliveryCostElement.totalShippingPrice ?? 0,
                  intl,
                )}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
